<template>
  <div class="recipes-page pb-5">
    <!-- Intro Section -->
    <div class="intro-blk pt-5 pb-4">
      <div class="text-center container">
        <h1 class="text-center m-0 text-campaign-green">RAISE A MARG & SALUD TO ALL SOULS</h1>
      </div>
    </div>

    <!-- Recipes List -->
    <div class="container-fluid p-0">
      <div v-for="marg in margaritas" :key="marg.id" class="row g-0 mb-3">
        <!-- Left: Image -->
        <div class="col-md-4 d-flex align-items-center justify-content-center" style="background-color: #008751;">
          <img :src="marg.imagepop" :alt="marg.title" class="img-fluid p-4"
            style="max-height: 450px; width: auto; object-fit: contain;" />
        </div>

        <!-- Right: Content -->
        <div :class="['col-md-8 d-flex align-items-center', marg.tintClass]">
          <div class="p-4 p-md-5 w-100">
            <h2 class="text-campaign-green text-uppercase m-0 recipe-title">{{ marg.title }}</h2>
            <p class="marg-desc mt-2 mb-4">{{ marg.desc }}</p>

            <div class="recipe-grid">
              <div class="row">
                <div class="col-md-6 mb-4">
                  <h4 class="text-campaign-green text-uppercase">METHOD</h4>
                  <p>{{ marg.method }}</p>
                </div>
                <div class="col-md-6 mb-4">
                  <h4 class="text-campaign-green text-uppercase">INGREDIENTS</h4>
                  <p v-html="marg.ingredients"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-4 mb-md-0">
                  <h4 class="text-campaign-green text-uppercase">GARNISH</h4>
                  <p v-html="marg.garnish"></p>
                </div>
                <div class="col-md-6">
                  <h4 class="text-campaign-green text-uppercase">GLASSWARE</h4>
                  <p>{{ marg.glassware }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMargaritas } from '../../data/margaritas';

export default {
  name: "Recipes",
  data() {
    return {
      margaritas: []
    };
  },
  mounted() {
    this.margaritas = getMargaritas(this.$t);
  }
};
</script>

<style scoped>
.recipe-title {
  font-size: 3.5rem;
  line-height: 1;
}

.marg-desc {
  font-size: 1.2rem;
  line-height: 1.4;
  color: #333;
  font-weight: 500;
  max-width: 900px;
}

.recipe-grid h4 {
  font-size: 1.6rem;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.recipe-grid p {
  font-size: 1.1rem;
  line-height: 1.4;
  color: #333;
  font-weight: 500;
  margin-bottom: 0;
}

@media screen and (max-width: 767px) {
  .recipe-title {
    font-size: 2.5rem;
    text-align: center;
  }

  .marg-desc {
    font-size: 1rem;
    text-align: center;
  }

  .recipe-grid h4 {
    font-size: 1.3rem;
  }

  .recipe-grid p {
    font-size: 1rem;
  }
}
</style>
